var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 13.9776C0 6.26355 6.26803 0.0101318 14 0.0101318C21.732 0.0101318 28 6.26362 28 13.9776C28 21.6917 21.732 27.9452 14 27.9452C6.26803 27.9452 0 21.6917 0 13.9776ZM15.2549 13.9776H18.0483L18.3917 10.222H15.4002V8.72008C15.4002 7.98844 15.8888 7.81784 16.2321 7.81784H18.344V4.60018L15.4363 4.58849C12.2085 4.58849 11.4751 6.98837 11.4751 8.52447V10.222H9.6085V13.9776H11.4904V23.3667H15.2549V13.9776Z","fill":"#FF8300"}));
}

FacebookInline.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
